import React from 'react';

import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { dataHooks } from '@wix/data-hooks';
import { FCWithChildren } from '@wix/challenges-web-library';
import { AlertCircleBoldSmall } from '@wix/wix-base-ui/icons';
import { Text } from '@wix/wix-base-ui';

import { st, classes } from './VideoError.st.css';

interface IVideoProps {
  type?: 'NOT_FOUND';
  className?: string;
}

export const videoErrorDataHooks = dataHooks<{
  main;
}>('video-error');

export const VideoError: FCWithChildren<IVideoProps> = (props) => {
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();

  return (
    <div
      className={st(classes.root, { mobile: isMobile }, props.className)}
      data-hook={videoErrorDataHooks.main()}
    >
      <Text size="medium" skin="standard" weight="thin">
        <AlertCircleBoldSmall />
      </Text>
      <Text size="medium" skin="standard" weight="thin">
        {t('live-site.step-video.video-not-found')}
      </Text>
    </div>
  );
};
